/* eslint-disable react/jsx-indent */
import * as React from 'react';
import { useIntl } from 'react-intl';
import PermissionsService, {
  PERMISSION_VEHICLE_GROUP_CUSTOMER,
  PERMISSION_VEHICLE_GROUP_PRIVATE,
} from '../../Services/PermissionsService';

interface IActionsProps {
  item: any;
  removeGroup: any;
  handleEditGroupModalOpening: any;
}

function Actions(props: IActionsProps): JSX.Element {
  const { formatMessage: f } = useIntl();

  return (
    <div className="p-2">
      {((props.item.type === 'private' &&
        PermissionsService.hasAccess(
          PERMISSION_VEHICLE_GROUP_PRIVATE,
          ['update'],
          props.item.customerId
        )) ||
        (props.item.type === 'public' &&
          PermissionsService.hasAccess(
            PERMISSION_VEHICLE_GROUP_CUSTOMER,
            ['update'],
            props.item.customerId
          ))) && (
        <a
          href="/"
          className="e-button e-button--gray e-button--square ml-xs my-xs"
          data-cy="cars-group-add-edit"
          onClick={props.handleEditGroupModalOpening}
          item-id={props.item.id}
          title={f({ id: 'carsGroups.addEdit' })}
        >
          <i className="cmd-icon-edit fs-5" />
        </a>
      )}
      {((props.item.type === 'private' &&
        PermissionsService.hasAccess(
          PERMISSION_VEHICLE_GROUP_PRIVATE,
          ['delete'],
          props.item.customerId
        )) ||
        (props.item.type === 'public' &&
          PermissionsService.hasAccess(
            PERMISSION_VEHICLE_GROUP_CUSTOMER,
            ['delete'],
            props.item.customerId
          ))) && (
        <a
          href="/"
          className="e-button e-button--gray e-button--square ml-xs my-xs"
          data-cy="cars-group-add-delete"
          onClick={props.removeGroup}
          data-id={props.item.id}
          title={f({
            id: 'carsGroups.addDelete',
          })}
        >
          <i className="cmd-icon-bin fs-5" />
        </a>
      )}
    </div>
  );
}

export default Actions;
